import template from './openBankingAssets.template.html';

export default {
  template,
  bindings: {
    data: '<',
    contacts: '<',
    onChange: '&'
  },
  controller: class controller {
    constructor($rootScope, listServiceNew) {
      'ngInject';

      const ctrl = this;
      ctrl.currentCurrency = null;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.data = ctrl.data || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.list.setData(ctrl.data);
        ctrl.list.deselectedData(ctrl.list.getSelected());
      };

      ctrl.getContactName = (ownership) => {
        const contact = _.find(ctrl.contacts || [], (c) => c?.id === ownership[0].idContact);
        return contact?.getName() || 'N/A';
      };

      ctrl.select = (data) => {
        ctrl.list.setSelected(data);
        ctrl.onChange({ data: ctrl.list.getSelected() });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
